/**
 * Кнопка «Открыть редактор» (Студия Рублокса).
 *
 * Переход в Студию — это сетевой запрос за одноразовым SSO-тикетом и
 * последующий редирект на другой домен. Раньше вызов выглядел так:
 *
 *     <button onClick={() => openStudio()}>Открыть редактор</button>
 *
 * Промис не ожидался и не имел `catch`. Отсюда три проблемы:
 *  • на медленной сети кнопка несколько секунд выглядела мёртвой,
 *    человек кликал повторно и выпускал лишние тикеты;
 *  • при ошибке тикета `openStudio` всё равно редиректит — и человек
 *    попадал в Студию гостем, видел окно входа и не понимал, почему;
 *  • ошибка уходила только в console.warn, то есть для пользователя
 *    её не существовало.
 */
import React, { useState } from "react";
import { openStudio } from "../api/playTicket";
import { Button } from "./ui";

export default function StudioButton({
  children = "Открыть редактор",
  variant = "primary",
  size = "lg",
  ...rest
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const go = async () => {
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await openStudio();
      /* Успех = уход со страницы. Снимать busy не нужно: если сюда
         вернулись (например, всплывашка заблокирована), кнопка должна
         остаться доступной — снимаем в catch/finally ниже. */
    } catch {
      setError("Не получилось открыть Студию. Попробуй ещё раз.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button variant={variant} size={size} onClick={go} loading={busy} {...rest}>
        {children}
      </Button>
      {error && <div className="rb-studio-btn__error">{error}</div>}
    </>
  );
}
